import { render, staticRenderFns } from "./PagesView.vue?vue&type=template&id=161cf307&scoped=true&"
import script from "./PagesView.vue?vue&type=script&lang=js&"
export * from "./PagesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161cf307",
  null
  
)

export default component.exports